// extracted by mini-css-extract-plugin
module.exports = {"container":"_6f25b66c20--container--3ZGA8","block":"_6f25b66c20--block--eE9-A","video-container":"_6f25b66c20--video-container--11cLS"};